import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useMatchListStore } from "../../../stores/StoreContext";
import LoadingIndicator from "../../../components/loadingIndicator/LoadingIndicator";
import { DeleteConfirmationModal } from "../../../components/modal/deleteConfirmationModal/DeleteConfirmationModal";
import { MatchCard } from "./Match";
import { MOBILE_SCREEN_WIDTH } from "../../../utils/constants";

type props = {};

export const AllMatchlist: React.FC<props> = observer(() => {
  const matchListStore = useMatchListStore();
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < MOBILE_SCREEN_WIDTH
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_SCREEN_WIDTH);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {matchListStore.matchList.length === 0 && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ marginTop: 20 }}>
          <p className="text-center" style={{ fontSize: "1.2rem" }}>
            No matches found
          </p>
        </div>
      )}
      <div
        style={{
          display: isMobile ? "flex" : "grid",
          gridTemplateColumns:
            !isMobile && matchListStore.matchList.length === 1
              ? "1fr"
              : "repeat(2, 1fr)",
          flexDirection: "column",
          gap: "16px",
          padding: isMobile ? undefined : "0 16px",
          width: "100%",
        }}>
        {matchListStore.matchList.map((match, idx) => {
          const isSingleCentered =
            !isMobile && matchListStore.matchList.length === 1;
          return (
            <div
              key={match.bookingId}
              style={{
                maxWidth: isSingleCentered ? 800 : "100%",
                margin: isSingleCentered ? "0 auto" : undefined,
                width: "100%",
              }}>
              <MatchCard match={match} index={idx} />
            </div>
          );
        })}
      </div>
      <LoadingIndicator loading={matchListStore.isLoading} />
      <DeleteConfirmationModal
        visible={matchListStore.modalData?.visible ?? false}
        title={matchListStore.modalData?.title ?? ""}
        description={matchListStore.modalData?.children ?? ""}
        onConfirm={matchListStore.modalData?.onAccept ?? (() => {})}
        onCancel={matchListStore.modalData?.onClose ?? (() => {})}
      />
    </>
  );
});
